export default {
  useMoreAddress: 'Use another address',
  hideAddress: 'Fold Address',
  productInventory: 'Commodity List',
  tag: 'Label',
  retainTag: 'Reserved label',
  delTag: 'Remove label',
  externalPack: 'Packing exterior',
  packDetail: 'Packing details',
  postLine: 'Delivery Route',
  selectLine: 'Select route',
  editLine: 'Modify route',
  service: 'Service',
  cancelServe: 'Cancel Service',
  previewPackage: 'Preview Parcel',
  postCountry: 'Sending country',
  packageNo: 'Parcel No.',
  deliver: 'Deliver to',
  packageDetail: 'Parcel details',
  addressInfo: 'Address Information',
  voWeight: 'Volume weight',
  firstWeight: 'First weight',
  continueWeight: 'Renewed weight',
  actWeight: 'Actual weight',
  packageStatus: 'Parcel status',
  freightDetail: 'Cost Information',
  declareCurrency: 'Declaration Currency',
  selfDeclare: 'Independent Declaration',
  packageDeclarePrice: 'The Total Amount Of Parcel Declaration',
  youPackageProduct: 'The Goods In Your Parcel',
  editYourDeclare: 'Please Edit Your Declaration Information',
  startDeclare: 'Start Filing',
  declareType: 'Type of declaration',
  productNo: 'Product ID',
  declareProductPrice: 'Declare unit price',
  declareTotalPrice: 'Total amount of goods declared',
  editDeclare: 'Modify declaration',
  declareLinePriceHint:
    'The lowest total amount declared for the current line: {min}, the highest: {max}',
  classMaxNumHint: 'The number of single categories has reached the upper limit {max}',
  addDeclareProduct: 'Add declared goods',
  plsConfirmInfo: 'Please confirm the information',
  wipePackProduct: 'Unpackaged goods',
  foldPackProduct: 'Foldable goods',
  wipeTagProduct: 'Unlabeled goods',
  aboutCalcWeightExplain:
    'As the parcel is not packed at present, we do not know the true weight of the parcel at this stage, so we can only rely on several existing parameters to estimate the weight of the parcel, so as to collect the deposit. After the parcel is packed and the true weight is obtained, more and less will be returned.',
  expressInfo: 'Logistics Information',
  deliveryMode: 'Mode of distribution',
  targetCountry: 'Target country',
  cancelPackage: 'Cancel parcel',
  cancelPackageHint:
    'Confirmed to cancel this parcel? You will not be able to recover after canceling.',
  isDelPackage: 'Confirmed to permanently delete the parcel?',
  delPackageHint:
    'After permanent deletion, you will no longer be able to view the parcel, please exercise caution!',
  receivedTips: 'Your parcel has been received, welcome to use it again',
  packageQuestion: 'There is a problem with the delivery of the parcel, you can',
  afterSale: 'Apply for after-sales service',
  repair: 'Repayment',
  ucan: 'You can',
  clickAdd: 'Click Add',
  addCategoryTips: 'There is no product name you want to declare',
  noCarrierLines: 'There are no shipping routes available',
  confirmPackageTitle: 'Have you confirmed receipt of the goods?',
  confirmPackageTips:
    'To protect your after-sales rights, please confirm receipt after verifying that the package is correct',
  receiptSuccess: 'Receipt successful',
  position: 'Position',
  time: 'Time',
  duty: 'Tax ID',
  inputTrueDuty: 'Please enter the correct Tax ID',
  serveStatusEnum: {
    1: 'Customized photos',
    2: 'Extend Storage Period',
    5: 'Customized Video',
  },
  inputCareTime: 'Please select storage time',
  holder: {
    noInputSearch: 'Parcel No./Product No.',
    inputEditDeclareInfo: 'Please edit your declaration information',
    packageRemark: 'If you have any other special requirements for the package, please note here',
    yourPriceSummary: 'Your price summary',
  },
  calcFee: 'Estimated fee',
  realFee: 'Actual fee',
  declare: {
    repeatDeclare: 'Type of duplicate declaration',
    addDeclareType: 'Please add declaration type',
  },
  feeEnum: {
    totalAmount: 'Estimated deposit',
    deposit: 'Estimated cost',
    overLongFee: 'Overlength fee',
    overWeightFee: 'Excess weight fee',
    remoteFee: 'Remote fees',
    feeCustoms: 'Logistics handling fee',
    feeFuel: 'Fuel surcharge',
    feeOperation: 'Operation Fee',
    feeService: 'Service fee',
    valueAddedTax: 'Value-added tax',
    insuranceService: 'Premium',
    incrementAmount: 'Value-added service fee',
    lineDiscount: 'Line discount',
    discount: 'VIP discounts',
    coupon: 'Select a coupon',
    passwordDiscount: 'Preferential password',
    orderPreDiscount: 'Merchandise discount',
    insuranceDiscount: 'Insurance concessionary',
    incrementDiscount: 'Value-added service offer',
    preVolumeCal: 'Estimated weighing',
    actDeposit: 'Freight after weighing',
    actDepositAmount: 'Final payment',
  },
  ratePaymentEnum: {
    name: 'Tax Payment Method',
    0: 'Paid by the recipient',
    1: 'Platform GST/VAT',
    2: 'Personal GST/VAT',
    3: 'Platform IOSS',
    4: 'Personal IOSS',
    5: 'Company GST/VAT',
    6: 'Logistics providers GST/VAT',
    7: 'Logistics providers IOSS',
    8: 'Tax-free',
  },
  bagStatusEnum: {
    0: 'Normal parcel',
    1: 'Domestic return',
    2: 'International return',
    3: 'Cancelled',
    4: 'Rechargement pending',
  },
  packageStatusEnum: {
    0: 'Awaiting processing',
    1: 'Processing',
    2: 'Collecting',
    3: 'Collected',
    4: 'Packing completed',
    5: 'Weighted',
    6: 'Waybill printed',
    7: 'Scanned',
    8: 'Delivered to carrier',
    9: 'Shipped',
    20: 'Received',
  },
  declareEnum: {
    name: 'Declaration Method',
    0: 'System Declaration',
    1: 'Personal Declaration',
  },
  backText: 'Back',
  packageInformation: 'Parcel Information',
  parcelNumber: 'Parcel No.',
  noValidRule: 'The declared amount does not pass the rules: {rule}',
  shippingAgree: 'acbuy Package Shipping Agreement',
  haveDiscountCode: 'I have discount code',
  inputDiscountCode: 'Input your discount code here',
  expressNo: 'Tracking number',
  shipping: 'Shipping',
  taxation: 'Taxation',
  acCare: 'Ac Care',
  discountCode: 'Discount Code',
  coupon: 'Coupon',
  rangeDeclare: 'Your total declared amount exceeds the range',
  noCouponData: 'No coupons meet the shipping discount conditions.',
  exchange: 'Exchange',
  'i18n-000001': 'Material',
  'i18n-000002': 'Color',
  'i18n-000003': 'Model/Size',
  'i18n-000004': 'Material',
  'i18n-000005': 'Declare or Not',
  'i18n-000006': 'Kindly Reminder',
  'i18n-000007':
    'Once submitted, Acbuy will not modify the declaration information.If the pre - clearance fails, we will still proceed with the shipment.',
  'i18n-000008':
    '1. According to the requirements of Brazilian Customs, please declare the name, material, color, model / size in detail, and the total name of the declaration should not exceed 5;',
  'i18n-000009':
    '2. Since small packages from Brazil are for personal use, multiple packages arriving at customs simultaneously will be detained. Please pick up multiple items separately；',
  'i18n-000010':
    '3. It is recommended that a single package should not exceed 4KG, and each commodity should be declared at least 3USD.For high - value products(game consoles, mobile phones, tablets, computers, etc.), truthfully declare to avoid customs seizure;',
  'i18n-000011':
    '4. Local tax standard in Brazil: 17 % ICMS + 20 % Duty is applied for the declaration of less than $50, and 17 % ICMS + 60 % Duty is applied for the declaration of more than $50.',
  'i18n-000012':
    '5. Please pay attention to the text messages and emails after the package arrives in Brazil, and pay the taxes in time',
  'i18n-000013': '{ num } items',
  'i18n-000014': 'Product name',
  cartonWarning:
    'Your parcel is too large in size or weight. We suggest using a cardboard box to achieve better compression and reduce the risk of damage during shipping',
  'i18n-0000003': 'Parcel Number',
  'i18n-0000004': 'Submission Time',
  'i18n-0000005': 'Estimated  Volume',
  'i18n-0000006': 'Estimated  Weight',
  'i18n-0000007': 'Estimated Cost',
  'i18n-0000009': 'Shipping Method',
  'i18n-0000010': 'Tracking Number',
  'i18n-0000011': 'Pending Payment',
  'i18n-0000017': 'Coupon Discount',
  'i18n-0000018': 'Shipping Address',
  'i18n-0000019': 'Declaration Information',
  'i18n-0000020': 'Product Declaration Name',
  'i18n-0000021': 'Declared Amount($)',
  'i18n-0000022': 'Quantity',
  'i18n-0000023': 'Subtotal($)',
  'i18n-0000024': 'Total Declared Amount',
  'i18n-0000025': 'Product Information',
  'i18n-0000026': 'Product',
  'i18n-0000027': 'Weight(g)',
  'i18n-0000028': 'Volume (cm³)',
  'i18n-0000029': 'Packaging Details',
  'i18n-0000033': 'Pending Refund',
  'i18n-0000034': 'Waiting for Additional Payment',
  'i18n-0000035': 'Actual Volume',
  'i18n-0000036': 'Charged Weight',
  'i18n-0000037': 'Actual Cost',
  'i18n-0000038': 'Actual Payment',
  'i18n-0000039': 'Parcel Photos',
  'i18n-0000040': 'Download Parcel Invoice',
  'i18n-0000041': 'Refunded to Wallet Balance',
  'i18n-0000042': 'Ref. ',
  'i18n-0000043': 'Additional Payment Made',
  'i18n-0000046': 'Expand',
  'i18n-0000047': 'Collapse',
  'i18n-0000048': 'Logistics track',
  'i18n-0000049': 'Weighing information',
  'i18n-0000050': 'Refunded',
  'i18n-0000051': 'Expected in Wallet within 72h',
  samePreviewTips:
    'This rehearsal parcel has already been submitted. Do you want to submit it again?',
  confirmSubmitTitle: 'Confirm and Continue',
  confirmSubmitText: 'Please confirm your shipping address:',
  confirmSubmitContent: `Shipping Address: {address}

Important Notice: The displayed chargeable weight is an estimated value. The final billing weight will be based on the actual measured weight after packaging, usually calculated by comparing the volumetric weight and actual weight, whichever is greater. If there is any difference between the estimated and final fees, we will adjust it accordingly under the “refund or supplement” policy.`,
}
